import { IconSet } from '@postscript/components';
import { PERMISSIONS } from 'components/account/AccountView/users/constants';
import { PS_PAY } from 'components/admin/utils/feature-flags';
import { useMemo } from 'react';
import { NavMenuItem } from '../NavMenu';

export const usePsPayMenuItems = (): NavMenuItem[] => {
  return useMemo(
    () => [
      {
        id: 'pspay',
        label: 'Text-to-Buy',
        icon: IconSet.PSTextToBuy,
        isLoading: false,
        ariaLabelledBy: 'nav-pspay-title',
        labsFeatureFlag: PS_PAY,
        restrictions: [PERMISSIONS.limit_sms_sales_agent_access],
        subMenu: [
          {
            link: '/pspay/manage',
            label: 'Branding',
            id: 'pspay-manage',
          },
        ],
      },
    ],
    [],
  );
};
